/**
 * Wrapper around the window location object.
 *
 * This makes JS unit testing possible as the window method cannot be spied on.
 * See: https://railsware.com/blog/2017/01/10/mocking-es6-module-import-without-dependency-injection/
 *
 * @param {String} [url] the page url to redirect to.
 * */
export function redirectTo(url) {
  window.location = url;
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/utils/window.js